/**
 * ユーザ権限
 */
export class UserRoles {
  // 管理者
  static readonly ADMIN = 'admin'
  // 塾
  static readonly ACADEMY = 'academy'
  // 教室
  static readonly BRANCH = 'branch'
  // 講師
  static readonly TEACHER = 'teacher'
  // 生徒
  static readonly STUDENT = 'student'
  // 採点者
  static readonly MARKER = 'marker'
}

/**
 * ユーザ管理・先生管理画面で表示する権限情報
 */
export class UserRoleSettings {
  // 管理者の設定
  static readonly ADMIN_ROLE: UserRoleSetting = {
    role: UserRoles.ADMIN,
    name: 'システム管理者',
  }
  // 塾管理者の設定
  static readonly ACADEMY_ROLE: UserRoleSetting = {
    role: UserRoles.ACADEMY,
    name: '塾管理者',
  }
  // 教室長の設定
  static readonly BRANCH_ROLE: UserRoleSetting = {
    role: UserRoles.BRANCH,
    name: '教室長',
  }
  // 講師の設定
  static readonly TEACHER_ROLE: UserRoleSetting = {
    role: UserRoles.TEACHER,
    name: '講師',
  }

  // 権限設定のリスト
  static readonly LIST = [
    UserRoleSettings.ADMIN_ROLE,
    UserRoleSettings.ACADEMY_ROLE,
    UserRoleSettings.BRANCH_ROLE,
    UserRoleSettings.TEACHER_ROLE,
  ]

  // 管理者が設定可能な権限一覧
  static readonly ADMIN_CONFIGURABLE: UserRoleConfigurable = {
    role: UserRoles.ADMIN,
    configurable: [
      UserRoleSettings.ADMIN_ROLE,
      UserRoleSettings.ACADEMY_ROLE,
      UserRoleSettings.BRANCH_ROLE,
      UserRoleSettings.TEACHER_ROLE,
    ],
  }
  // 塾管理者が設定可能な権限一覧
  static readonly ACADEMY_CONFIGURABLE: UserRoleConfigurable = {
    role: UserRoles.ACADEMY,
    configurable: [UserRoleSettings.ACADEMY_ROLE, UserRoleSettings.BRANCH_ROLE, UserRoleSettings.TEACHER_ROLE],
  }
  // 教室長が設定可能な権限一覧
  static readonly BRANCH_CONFIGURABLE: UserRoleConfigurable = {
    role: UserRoles.BRANCH,
    configurable: [UserRoleSettings.BRANCH_ROLE, UserRoleSettings.TEACHER_ROLE],
  }
  // 講師が設定可能な権限一覧
  static readonly TEACHER_CONFIGURABLE: UserRoleConfigurable = {
    role: UserRoles.TEACHER,
    configurable: [UserRoleSettings.TEACHER_ROLE],
  }
  // 権限毎の設定可能権限一覧
  static readonly CONFIGURABLE_LIST: UserRoleConfigurable[] = [
    UserRoleSettings.ADMIN_CONFIGURABLE,
    UserRoleSettings.ACADEMY_CONFIGURABLE,
    UserRoleSettings.BRANCH_CONFIGURABLE,
    UserRoleSettings.TEACHER_CONFIGURABLE,
  ]

  // 権限で設定可能一覧を取得する
  static findConfigurableByRole(role: UserRoles): UserRoleSetting[] {
    return (
      UserRoleSettings.CONFIGURABLE_LIST.find((configurable) => {
        return configurable.role === role
      })?.configurable || []
    )
  }

  // 権限で権限設定情報を取得
  static findByRole(role: UserRoles): UserRoleSetting | undefined {
    return UserRoleSettings.LIST.find((userRole) => {
      return userRole.role === role
    })
  }
}

export type UserRoleSetting = {
  // 権限
  role: UserRoles
  // 権限名
  name: string
}

export type UserRoleConfigurable = {
  // 権限
  role: UserRoles
  // 設定可能な権限
  configurable: UserRoleSetting[]
}
